import { Axios } from "./request";

const API_URL = "usersapi/v1/educationType/";

export const EDUCATION_TYPE_API = {
  GetEducationTypesDropDown: (isMainEducationDegree) => {
    return Axios.get(
      `${API_URL}GetEducationTypesDropDown?isMainEducationDegree=${isMainEducationDegree}`
    );
  },
};
